<template>
  <div>
    <b-modal
      :title="modalTitle"
      ok-title="ذخیره"
      cancel-title="لغو"
      id="newEditRule"
      @ok.prevent="SaveRule"
    >
      <b-form-group label="کد درگاه:">
        <b-form-input v-model="itemToSave.gatewayId"></b-form-input>
      </b-form-group>
      <b-form-group label="حداقل مبلغ:">
        <NumberSeprator v-model="itemToSave.minAmount"></NumberSeprator>
      </b-form-group>
      <b-form-group label="حداکثر مبلغ:">
        <NumberSeprator v-model="itemToSave.maxAmount"></NumberSeprator>
      </b-form-group>
      <b-form-group label="نوع پرداخت:">
        <b-form-select
          v-model="itemToSave.method"
          :options="[
            {
              text: 'داخلی',
              value: 'INTERNAL',
            },
            {
              text: 'ساتنا',
              value: 'SATNA',
            },
            {
              text: 'پایا',
              value: 'PAYA',
            },
          ]"
        ></b-form-select>
      </b-form-group>
      <b-form-group label="اولویت:">
        <NumberSeprator v-model="itemToSave.priority"></NumberSeprator>
      </b-form-group>
      <b-form-group label="پروایدر:">
        <b-form-select
          @change="ProviderChanged"
          v-model="itemToSave.provider"
          :options="banksProviders"
        ></b-form-select>
        <div class="mt-2">
          {{ selectedProvider.data ? selectedProvider.data.iban : "" }}
        </div>
      </b-form-group>
      <b-form-group label="بانک های مقصد:">
        <b-form-checkbox
          v-for="(item, index) in this.banksOptions"
          :key="index"
          :checked="itemToSave.destinationBanks.indexOf(+item.value) > -1"
          v-model="itemToSave.destinationBanks"
          :value="item.value"
        >
          {{ item.text }}
        </b-form-checkbox>
      </b-form-group>
    </b-modal>
    <b-card>
      <div class="mb-2">
        <b-button @click="newRule" variant="success" class=""
          >قانون جدید</b-button
        >
      </div>
      <b-table responsive :items="data" :fields="fields">
        <template v-slot:cell(action)="row">
          <b-button variant="info" @click="editRule(row)" class="btn btn-sm p-1"
            >ویرایش</b-button
          >
          <b-button
            variant="danger"
            @click="deleteRule(row)"
            class="btn btn-sm p-1 ml-1"
            >حذف</b-button
          >
          <b-button
            v-if="!row.item.isActive"
            variant="success"
            @click="activeRule(row)"
            class="btn btn-sm p-1 ml-1"
            >فعال</b-button
          >
          <b-button
            v-if="row.item.isActive"
            variant="warning"
            @click="deactiveRule(row)"
            class="btn btn-sm p-1 ml-1"
            >غیر فعال</b-button
          >
        </template>
      </b-table>
    </b-card>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import NumberSeprator from "../../components/numberSeprator.vue";
export default {
  name: "TransferRules",
  components: {
    NumberSeprator,
  },
  data() {
    return {
      data: [],
      banks: [],
      banksOptions: [],
      banksProviders: [],
      selectedProvider: {},
      modalTitle: "قانون جدید",
      itemToSave: {
        destinationBanks: [],
      },
      fields: [
        {
          key: "minAmount",
          label: "حداقل مبلغ",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "maxAmount",
          label: "حداکثر مبلغ",
          formatter(value, key, item) {
            if (!value) return "----";
            return Number(value).toLocaleString();
          },
        },
        {
          key: "method",
          label: "نوع پرداخت",
          formatter(value, key, item) {
            switch (value) {
              case "INTERNAL":
                return "داخلی";
              case "SATNA":
                return "ساتنا";
              case "PAYA":
                return "پایا";
            }
          },
        },
        {
          key: "priority",
          label: "اولیت",
        },
        {
          key: "provider",
          label: "پروایدر",
          formatter: (value, key, item) => {
            return value.text;
          },
        },
        {
          key: "destinationBanks",
          label: "بانک های مقصد",
          formatter: (value, key, item) => {
            var names = "";
            for (let i = 0; i < value.length; i++) {
              if (i > 2) {
                names += "...";
                break;
              }
              const element = value[i];
              names += this.banks[element];
              if (i != value.length - 1) names += ", ";
            }
            return names;
          },
        },
        {
          key: "isActive",
          label: "وضعیت",
          formatter(value, key, item) {
            if (value) return "فعال";
            return "غیر فعال";
          },
          tdClass(value, key, item) {
            if (value) return "text-bold text-success";
            return "text-bold text-danger";
          },
        },
        {
          key: "action",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    getProviderLable(element) {
      if (this.banksProviders) {
        return this.banksProviders.find((t) => {
          return t.data.nickname == element;
        });
      }
      return element;
    },
    ProviderChanged(event) {
      this.selectedProvider = this.banksProviders.find((t) => {
        return t.value == event;
      });
    },
    editRule(row) {
      this.modalTitle = "ویرایش";
      this.itemToSave = row.item;
      this.$bvModal.show("newEditRule");
    },
    deleteRule(row) {
      const idToDelete = row.item.id;
      //   delete this.itemToSave.id;
      httpHelper
        .DeleteData("~transfer-strategy/rules/" + idToDelete, {})
        .then((res) => {
          this.loadData();
        });
    },
    newRule() {
      this.modalTitle = "قانون جدید";
      this.itemToSave = {
        destinationBanks: [],
      };
      this.$bvModal.show("newEditRule");
    },
    SaveRule() {
      if (this.itemToSave.id) {
        const idToSave = this.itemToSave.id;
        delete this.itemToSave.id;
        httpHelper
          .PutData("~transfer-strategy/rules/" + idToSave, this.itemToSave)
          .then((res) => {
            this.itemToSave = {
              destinationBanks: [],
            };
            this.loadData();
            this.$bvModal.hide("newEditRule");
          });
      } else {
        httpHelper
          .postData("~transfer-strategy/rules", this.itemToSave)
          .then((res) => {
            this.itemToSave = {
              destinationBanks: [],
            };
            this.loadData();
            this.$bvModal.hide("newEditRule");
          });
      }
    },
    loadData() {
      httpHelper.getData("~transfer-strategy/rules").then((records) => {
        this.data = records.data;
        for (let i = 0; i < this.data.length; i++) {
          const element = this.data[i];
          element.provider = this.getProviderLable(element.provider);
        }
      });
    },
    activeRule(row) {
      this.itemToSave = row.item;
      this.itemToSave.isActive = true;
      delete this.itemToSave.id;
      httpHelper
        .PutData("~transfer-strategy/rules/" + idToSave, this.itemToSave)
        .then((res) => {
          this.loadData();
        });
    },
    deactiveRule(row) {
      const idToSave = row.item.id;
      this.itemToSave = row.item;
      this.itemToSave.isActive = false;
      delete this.itemToSave.id;
      httpHelper
        .PutData("~transfer-strategy/rules/" + idToSave, this.itemToSave)
        .then((res) => {
          this.loadData();
        });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "قوانین انتقال وجه" }]);
    httpHelper.getData("~transfer-strategy/banks").then((res) => {
      this.banks = res.data;
      for (const key in this.banks) {
        if (Object.prototype.hasOwnProperty.call(this.banks, key)) {
          const element = this.banks[key];
          this.banksOptions.push({
            text: element,
            value: key,
          });
        }
      }
      httpHelper.getData("~transfer-strategy/banks/providers").then((res) => {
        this.banksProviders = res.data.map((res) => {
          return {
            text: res.label,
            value: res.nickname,
            data: res,
          };
        });
        this.loadData();
      });
    });
  },
};
</script>